import { GeoshapeAdapter, GeoshapeStyle } from '@leverege/ui-mapbox-elements';
import Model from "../../shared/renderers/UserPositionModel.js";
import Symbolizers from "../../shared/Symbolizers.js";
const {
  SYMBOL_LAYOUT
} = GeoshapeStyle;
const SYMBOL_TYPE = 'userPosition';
export default class UserPositionAdapter extends GeoshapeAdapter {
  getShapeData(item, id, options) {
    const {
      model,
      symbols
    } = options;
    const app = {
      visible: true,
      name: model.name
    };
    const geoJson = {
      type: 'Feature',
      properties: {},
      geometry: {
        type: 'Point',
        coordinates: [item.longitude, item.latitude]
      }
    };
    const subtype = Symbolizers.getSymbol(model.symbolizer, item, null);
    app.isRollover = false;
    app.isSelected = false;
    app.showSymbol = true;
    app.showLabel = false;
    app.symbol = Array.isArray(subtype) ? symbols.getTypeSymbol(subtype[0] || SYMBOL_TYPE, subtype[1], app.isRollover, app.isSelected) : symbols.getTypeSymbol(SYMBOL_TYPE, subtype, app.isRollover, app.isSelected);
    return {
      dataType: 'userPosition',
      geoJson,
      appearance: app
    };
  }
  getSymbolLayout(style, layerGroup, options) {
    const {
      model
    } = options;
    const scale = model && Model.getScale(model) || 1;
    const scalesWithZoom = model && Model.getScalesWithZoom(model) || false;
    const scaleTo = model && Model.getScaleToZoom(model) || 10;
    const scaleFrom = model && Model.getScaleFromZoom(model) || scaleTo - 4;
    const toFac = model && Model.getScaleToFactor(model) || 1;
    const fromFac = model && Model.getScaleFromFactor(model) || 0;
    const flip = scaleTo < scaleFrom;
    let size = 0.5 * scale;
    if (scalesWithZoom) {
      size = {
        stops: flip ? [[scaleTo, size * toFac], [scaleFrom, size * fromFac]] : [[scaleFrom, size * fromFac], [scaleTo, size * toFac]],
        default: size
      };
    }
    return {
      ...SYMBOL_LAYOUT,
      'icon-size': size
    };
  }
}